import React from 'react';
import axios from 'axios';
import { Alert, Card, Form, Radio, Select, Spin, notification } from 'antd';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import stickyError from 'components/stickyError';
import PaymentTriggerForm from 'components/PaymentTriggerForm';
import PermissionSplash from 'components/PermissionSplash';

class InfoCard extends React.Component {
	render() {
		return (
			<Card>
				All <strong>students and Lifelong Learners</strong> are required to take the provided shuttles to Ensenada, Mexico on January 4, 2020. This transport is at no additional charge.
				<br /><br />
				Shuttles will depart from the <a href="https://www.marriott.com/hotels/travel/sandh-springhill-suites-san-diego-downtown-bayfront/" target="_blank">Springhill Suites San Diego Downtown Bayfront Hotel</a> in San Diego, California. Shuttle check-in and luggage drop off will be located on the 5th floor of the hotel. Please plan to arrive at your "boarding time," which is 20 minutes prior to scheduled departure.
				<br /><br />
				Travel time is approximately 2 hours. Please bring a pen to fill out mandatory immigration forms at the US-MX border.
				<br /><br />
				We cannot accommodate time requests or changes.
				<br /><br />
				If you have any questions, contact our Program Administration department at 800.854.0195 or <a href="mailto:programadministration@semesteratsea.org">programadministration@semesteratsea.org</a>.

				{false && this.props.showQuestion &&
					<p>
						<strong>Would you like to request a SAS-arranged Convenience Shuttle or will you arrive independently in Bremerhaven?</strong>
					</p>
				}
			</Card>
		);
	}
}

class Embarkation extends React.Component {
	state = {
		chargeTotal: null,
		creditTotal: null,
		shuttleBooked: null,
		transportType: 'shuttle',
		shuttleTimes: [],
		shuttleTimesLoaded: false,
		embarkationTimes: [],
		embarkationTimesLoaded: false,
		selectedTime: 'none',
		allPossibleItems: []
	}
	bookingHasShuttle = (booking, times) => {
		let shuttle = false;
		booking.map(item => {
			let shuttleTime = times.find(time => time.ItemId === item.ItemId);
			if (!!shuttleTime) shuttle = shuttleTime;
			return null;
		});
		if (!shuttle) {
			shuttle = !!booking.find(item => item.StoreId === '41');
		}
		return shuttle;
	}
	checkBookingForShuttle = (props) => {
		if (!props || !props.bookingLoaded) return null;
		if (!this.state.shuttleTimesLoaded || !this.state.embarkationTimesLoaded) {
			return setTimeout(this.checkBookingForShuttle.bind(this, props), 500);
		} else {
			return this.setState({
				shuttleBooked: this.bookingHasShuttle(
					props.bookedItems,
					this.state.allPossibleItems
				)
			});
		}
	}
	itemToObject = (item) => {
		return {
			key: item.ItemId,
			label: item.Name,
			BegDate: item.BegDate,
			EndDate: item.EndDate,
			BegLocation: item.BegLocation,
			EndLocation: item.EndLocation,
			AvailItems: parseInt(item.AvailItems, 10)
		};
	}
	getShuttleAndEmbarkationTimes = () => {
		axios.get(apiPath + '/shuttles').then(result => {
			const items = result.data
				.filter(item => item.EventId === '39' && item.ItemId !== '1175' && item.ItemId !== '1176')// && item.Price !== null)
				.sort((a, b) => a.Name !== b.Name ? a.Name < b.Name ? -1 : 1 : 0);
			this.setState({
				shuttleTimesLoaded: true,
				shuttleTimes: items.map(this.itemToObject),
				embarkationTimesLoaded: true,
				embarkationTimes: [],//items.filter(item => item.Code.indexOf('HAM 100-11') !== -1).map(this.itemToObject),
				allPossibleItems: result.data
			});
		}).catch(this.props.handleAxiosLoadError);
	}
	getBalance = (props) => {
		if (props.bookingLoaded) {
			this.setState({
				chargeTotal: props.chargeTotal,
				creditTotal: props.creditTotal
			});
		}
	}
	handleTypeChange = (event) => {
		if (this.state.transportType !== null) this.props.form.setFieldsValue({ transportItemId: 'none' });
		this.setState({
			transportType: event.target.value,
			selectedTime: 'none'
		});
	}
	handleTimeChange = (time) => this.setState({ selectedTime: time });
	preCheckout = () => {
		return new Promise((resolve, reject) => {
			this.props.form.validateFields((error, values) => {
				if (error) {
					stickyError(error);
					reject(error);
				} else {
					if (values.transportItemId !== 'none') {
						const times = (this.state.transportType === 'shuttle') ? this.state.shuttleTimes : this.state.embarkationTimes;
						axios.put(apiPath + '/shuttleitem', {
							ItemId: values.transportItemId,
							BegDate: times.find(time => time.key === values.transportItemId).BegDate.split('T')[0] + 'T00:00:00',
							EndDate: times.find(time => time.key === values.transportItemId).EndDate.split('T')[0] + 'T00:00:00',
							BegLocation: times.find(time => time.key === values.transportItemId).BegLocation,
							EndLocation: times.find(time => time.key === values.transportItemId).EndLocation
						}, {
								withCredentials: true
							}).then(result => {
								resolve();
							}).catch(error => {
								this.getShuttleAndEmbarkationTimes();
								this.props.refreshBooking().then(booking => {
									reject({
										message: (error.response.status === 409) ?
											error.response.data :
											'Failed reserve ' + ((this.state.transportType === 'shuttle') ? 'shuttle' : 'check-in time') + ', please try again.'
									});
								});
							});
					} else {
						notification.info({ message: values.transportType + ' transportation, ItemId ' + values.transportItemId });
						resolve();
					}
				}
			});
		});
	}
	componentDidMount() {
		this.checkBookingForShuttle(this.props);
		this.getShuttleAndEmbarkationTimes();
		this.getBalance(this.props);
	}
	componentWillReceiveProps(nextProps) {
		this.checkBookingForShuttle(nextProps);
		this.getBalance(nextProps);
	}
	render() {
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'Embarkation' && role.access_read === "1")
		}) : false

		
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			if (this.state.shuttleBooked === null) {
				return <div style={{ textAlign: 'center', marginBottom: '16pt' }}><Spin /></div>
			}
			else if (this.state.shuttleBooked) {
				return (
				


					<div>
						<Alert showIcon
							type="success"
							message={'You are booked'}
							description={<span>
								{(this.state.shuttleBooked.Name) ? this.state.shuttleBooked.Name : 'You have chosen a shuttle already'}
							</span>} />
						<br />
						<InfoCard />
					</div>
				
				);
			}
			
			
			else {
				return (
					<div>
						<InfoCard />
						{/* <PermissionSplash /> */}
					</div>
				);
			}
		
		}
		
		const { getFieldDecorator } = this.props.form;
		const times = (this.state.transportType === 'shuttle') ? this.state.shuttleTimes : this.state.embarkationTimes;

		let shuttleTotal = 45;
		let { chargeTotal, creditTotal } = this.state;
		const accountCredit = (creditTotal > chargeTotal) ? creditTotal - chargeTotal : 0;
		shuttleTotal -= accountCredit;
		if (shuttleTotal < 0) shuttleTotal = 0;
		
		if (this.props.variant === 'admin' && read === true) {
			return (
				


				<div>
					{(!this.state.shuttleTimesLoaded || !this.state.embarkationTimesLoaded || !this.props.bookingLoaded) &&
						<div style={{ textAlign: 'center', marginBottom: '16pt' }}><Spin /></div>
					}
					{/* {moment().isBefore('2017-12-08T00:00') && */}
					<div>
						<Form>
							<Alert type="warning" showIcon
								message="Independent travel to Ensenada is not permitted."
								description="All students and Lifelong Learners are required to take the provided buses to Ensenada. If you do not request a shuttle time here, you will be automatically assigned." />
							<br />
							<InfoCard showQuestion />
							<br />
							{false &&
								<Form.Item>
									{getFieldDecorator('transportType', {
										rules: [{ required: true }],
										initialValue: this.state.transportType
									})(
										<Radio.Group onChange={this.handleTypeChange} style={{ fontWeight: 'bold' }}>
											<Radio.Button value="shuttle">I want to register for a SAS-arranged shuttle</Radio.Button>
											<Radio.Button value="own">I will arrive independently in Bremerhaven</Radio.Button>
										</Radio.Group>
									)}
								</Form.Item>
							}
							{this.state.transportType !== null &&
								<div>
									Select your {(this.state.transportType === 'shuttle') ? 'shuttle' : 'embarkation check-in'} time:
									<Form.Item>
										{getFieldDecorator('transportItemId', {
											initialValue: 'none',
											rules: [{ required: true }]
										})(
											<Select onChange={this.handleTimeChange}>
												<Select.Option key="none">Choose a time</Select.Option>
												{times.map(time =>
													<Select.Option
														key={time.key}
														disabled={time.AvailItems <= 0}>
														{time.label + ((time.AvailItems <= 0) ? ' - Full' : '')}
													</Select.Option>
												)}
											</Select>
										)}
									</Form.Item>
								</div>
							}
							{false && this.state.transportType === 'shuttle' && shuttleTotal < 45 &&
								<Alert showIcon type="info"
									message={'Your field program credit will be applied to this transaction, bringing your total to $' + shuttleTotal} />
							}
						</Form>
						{this.state.transportType !== null &&
							<div style={{ textAlign: 'right' }}>
								<PaymentTriggerForm
									kickSession={this.props.kickSession}
									orderno_prefix="FLD"
									preCheckout={this.preCheckout}
									refreshBooking={this.props.refreshBooking}
									booking={this.props.bookingLoaded && this.props.booking}
									disabled={this.state.selectedTime === 'none'}
									showIcon={false}
									buttonText={(this.state.transportType === 'shuttle') ? 'Request Shuttle' : 'Confirm Check-in Time'}
									total={0}
									redirectIfFree={"/portal/embarkation"} />
							</div>
						}
					</div>
					{/*  } */}
					{/* {moment().isAfter('2017-12-08T00:00') &&
					<Alert type="info" showIcon
						message="Shuttle registration has closed. If you did not request a shuttle time, you will be automatically assigned to one" />
				} */}
				</div>
			
				);
		} else {
			return (

				<PermissionSplash />

			);
		}
	

	}
}

export default Form.create()(Embarkation);


// WEBPACK FOOTER //
// ./portal-components/Portal/Embarkation/index.jsx